import React from "react";
import { Link } from "react-router-dom";
import paths from "../../routes/paths";

function Footer() {
    return (
        <footer class="footer p-10">
            <div className="xl:pl-16 lg:pl-10">
                <span class="footer-title text-[#004987]">Cetaphil Myanmar</span>
                <Link to={paths.about} className="link link-hover" >About Us</Link>
                <Link to={paths.contact} className="link link-hover" >Contact</Link>
                <a href="https://cetaphilmyanmar.com/terms" className="link link-hover" >Terms & Condition</a>
            </div>
            <div>
                <span class="footer-title text-[#004987]">Shop</span>
                <a class="link link-hover">Cleanser</a>
                <a class="link link-hover">Moisturizer</a>
                <a class="link link-hover">Sun Protection</a>
                <a class="link link-hover">Cetaphil Baby</a>
            </div>
            <div>
                <span class="footer-title">Social</span>
                <div class="grid grid-flow-col gap-4">
                    <a><svg xmlns="https://www.facebook.com/cetaphilmyanmar" width="24" height="24" viewBox="0 0 24 24" class="fill-current"><path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"></path></svg></a>
                </div>
            </div>
        </footer>
    );
}

export default Footer;